import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Button, FormHelperText, Typography as MuiTypography } from '@material-ui/core';
import { SearchInput } from 'components';
import Grid from '@material-ui/core/Grid';
import ToggleButton from '@material-ui/lab/ToggleButton';
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import { Values } from '../../../../values/Values';

const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    display: 'flex',
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1)

  },
  search: {
    alignItems: 'center',
    marginTop: theme.spacing(3),
    marginRight: theme.spacing(1)
  },
  componentsSearch: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(3),
    marginRight: theme.spacing(1)
  },
  spacer: {
    flexGrow: 1
  },
  importButton: {
    marginRight: theme.spacing(1)
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  searchInput: {
    marginRight: theme.spacing(1)
  }
}));

const EstoqueInsumoMovimentacaoToolbar = props => {
  const {
    className,
    filterMovimentacoes,
    filtroDescricaoInsumo,
    setFiltroDescricaoInsumo,
    filtroAtivo,
    setFiltroAtivo,
    setPage,
    insumos,
    insumosFiltrosSelecionados,
    setInsumosFiltrosSelecionados,
    filtroTipoMovimentacaoSelecionado,
    setFiltroTipoMovimentacaoSelecionado,
    filtroDataInicial,
    setFiltroDataInicial,
    filtroDataFinal,
    setFiltroDataFinal,
    carregarMovimentacoesMetadadosFiltrado,
    ...rest } = props;
  const [filterValue, setFilterValue] = useState('');
  const [resfreshState, setRefreshState] = useState(new Date());
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;
  const classes = useStyles();

  function filter() {
    setPage(1);
    if(filterValue !== ''){
      setFiltroAtivo(true);
      setFiltroDescricaoInsumo(filterValue);
      filterMovimentacoes()
    }
    else{
      setFiltroAtivo(false);
      setFiltroDescricaoInsumo(filterValue);
      filterMovimentacoes()
    }

  }

  function aoModificarFiltroInsumos(event, arrayInsumos) {
    setInsumosFiltrosSelecionados(arrayInsumos);
  }

  function modificarFiltroTipoMovimentacao(tipoMovimentacao) {
    setFiltroTipoMovimentacaoSelecionado(tipoMovimentacao);
    setRefreshState(new Date());
  }

  const modificarDataInicial = date => {
    setFiltroDataInicial(date);
  };

  const modificarDataFinal = date => {
    setFiltroDataFinal(date);
  };

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >

      <div className={classes.componentsSearch}>
        <Grid
          container
          spacing={2}
        >
          <Grid
            item
            md={12}
            xs={12}
          >
            <Autocomplete
              fullWidth
              multiple
              limitTags={5}
              size="small"
              id="lojas"
              options={insumos.result}
              value={insumosFiltrosSelecionados}
              onChange={aoModificarFiltroInsumos}
              disableCloseOnSelect
              margin={'dense'}
              openOnFocus
              getOptionLabel={insumo => insumo.descricao}
              renderOption={(insumo, { selected }) => (
                <React.Fragment>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={selected}
                  />
                  {insumo.descricao}
                </React.Fragment>
              )}
              style={{ marginTop: 17 }}
              renderInput={params => (
                <TextField
                  {...params}
                  variant="outlined"
                  label="Insumos"
                  helperText={'Insira a data final para filtro da movimentação'}
                  placeholder="Marque os insumos que deseja filtrar"
                  fullWidth
                  margin='dense'
                />
              )}
            />
          </Grid>
          <Grid
            item
            md={3}
            xs={12}
          >
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Grid container justify="space-around">
                <KeyboardDatePicker
                  fullWidth
                  margin={'none'}
                  inputVariant="outlined"
                  orientation="landscape"
                  id="dataMovimentacaoInicial"
                  label="Data inicial"
                  helperText={'Insira a data incial para filtro da movimentação'}
                  format="dd/MM/yyyy"
                  size='small'
                  value={filtroDataInicial}
                  onChange={modificarDataInicial}
                  // onKeyPress={(ev) => {
                  //   if (ev.key === 'Enter') {
                  //     // Do code here
                  //     ev.preventDefault();
                  //     filterFiliados(filterValue, date01, date02);
                  //   }
                  // }}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                  InputAdornmentProps={{ position: "end" }}
                />

              </Grid>
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid
            item
            md={3}
            xs={12}
          >
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Grid container justify="space-around">
                <KeyboardDatePicker
                  fullWidth
                  margin={'none'}
                  inputVariant="outlined"
                  orientation="landscape"
                  id="dataMovimentacaoFinal"
                  label="Data final"
                  helperText={'Insira a data final para filtro da movimentação'}
                  format="dd/MM/yyyy"
                  size='small'
                  value={filtroDataFinal}
                  onChange={modificarDataFinal}
                  // onKeyPress={(ev) => {
                  //   if (ev.key === 'Enter') {
                  //     // Do code here
                  //     ev.preventDefault();
                  //     filterFiliados(filterValue, date01, date02);
                  //   }
                  // }}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                  InputAdornmentProps={{ position: "end" }}
                />

              </Grid>
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid
            item
            md={3}
            xs={12}
          >
            <FormControl fullWidth component="fieldset">
              <ButtonGroup fullWidth color="primary" aria-label="outlined primary button group">
                <Button
                  fullWidth
                  variant={!filtroTipoMovimentacaoSelecionado ? 'contained' : 'outlined'}
                  color={'primary'}
                  onClick={e => modificarFiltroTipoMovimentacao(undefined)}
                >
                  Todos
                </Button>
                <Button
                  fullWidth
                  variant={filtroTipoMovimentacaoSelecionado === Values.estoqueInsumoMovimentacao.tipoMovimentacao.positiva ? 'contained' : 'outlined'}
                  color={'primary'}
                  onClick={e => modificarFiltroTipoMovimentacao(Values.estoqueInsumoMovimentacao.tipoMovimentacao.positiva)}
                >
                  Entrada
                </Button>
                <Button
                  fullWidth
                  color={'primary'}
                  variant={filtroTipoMovimentacaoSelecionado === Values.estoqueInsumoMovimentacao.tipoMovimentacao.negativa ? 'contained' : 'outlined'}
                  onClick={e => modificarFiltroTipoMovimentacao(Values.estoqueInsumoMovimentacao.tipoMovimentacao.negativa)}
                >
                  Saída
                </Button>
              </ButtonGroup>
              <FormHelperText margin={'dense'}>Escolha o tipo de movimentação</FormHelperText>
            </FormControl>
          </Grid>
          <Grid
            item
            md={3}
            xs={12}
          >
            <Button
              style={{width: '100%'}}
              color="primary"
              variant="contained"
              fullWidth
              onClick={e => carregarMovimentacoesMetadadosFiltrado()}
            >
              Pesquisar
            </Button>
          </Grid>

        </Grid>
      </div>
    </div>
  );
};

EstoqueInsumoMovimentacaoToolbar.propTypes = {
  className: PropTypes.string
};

export default EstoqueInsumoMovimentacaoToolbar;
